import React from "react";
import {
  SkeletonContainer,
  SkeletonItem,
  SkeletonIcon,
  SkeletonHeader,
  SkeletonProgress,
} from "./index.styled";

const CampaignSummarySkeleton: React.FC = () => {
  return (
    <SkeletonContainer>
      <SkeletonIcon />
      {Array.from({ length: 4 }).map((_, index) => (
        <SkeletonItem key={index} $delay={index * 0.1}>
          <SkeletonHeader>
            <div className="skeleton-title" />
            <div className="skeleton-value" />
          </SkeletonHeader>
          <SkeletonProgress />
        </SkeletonItem>
      ))}
    </SkeletonContainer>
  );
};

export default CampaignSummarySkeleton;
